import { Module } from 'vuex';
import { IRootState } from '@/store';
import { IEmployeeState } from './employee.types';
import { IEmployeeData, IEmployeeWorkScheduleData } from '@/models';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: IEmployeeState = {
  version: 1,
  employees: [] as IEmployeeData[],
  employeeWorkSchedule: null as IEmployeeWorkScheduleData | null,
  salaryEmployeeUsers: [],
  supervisorEmployees: [],
  employeeTeamDepartments: [],
  count: 0,
  lastPromise: null
};

const namespaced = true;

export const employee: Module<IEmployeeState, IRootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
